import { Handle, Position } from "@xyflow/react";
import TableChartIcon from '@mui/icons-material/TableChart';
import { Box, Typography, useTheme } from "@mui/material";
import ReusableNodes, { NodeError, NodeHandles, NodeHeader, NodeWarning } from "../../../../../components/ReusableNodes";
import { CustomTooltip } from "../../../../../components/TooltipCustomStyle";
import ErrorIcon from '@mui/icons-material/Error';
import TooltipStatusTitle from "../../../../../components/TooltipStatusTitle";
import isSelectedAndHighlight from "../../../../../utils/isSelectedAndHighlight";
// import DrgIcon from "../../drgicons/DrgIcon";

export default function CustomAuthorizationNode({ data, selected, id, onNodeClick }) {

    const theme = useTheme();

    const label = data.general_properties.resource;
    const description = data.general_properties.description;

    const handleNodeClick = (event) => {
        event.stopPropagation(); // ป้องกัน event bubbling
        if (onNodeClick) {
            onNodeClick(event, id);
        }
    };

    const nodeHandles = ({ headerAnchorY } = {}) => {
        const handleClassName = `drg-handle ${selected ? 'drg-selected-handle' : ''}`;

        const sideHandleStyle = typeof headerAnchorY === 'number'
            ? { top: `${headerAnchorY}px` }
            : undefined;

        return (
            <div>
                <Handle
                    id="top-target"
                    type="target"
                    position={Position.Top}
                    className={handleClassName}
                    isConnectableStart={false}
                    isConnectableEnd={true}
                />
                <Handle
                    id="bottom-target"
                    type="target"
                    position={Position.Bottom}
                    className={handleClassName}
                    isConnectableStart={false}
                    isConnectableEnd={true}
                />
                <Handle
                    id="left-target"
                    type="target"
                    position={Position.Left}
                    style={sideHandleStyle}
                    className={handleClassName}
                    isConnectableStart={false}
                    isConnectableEnd={true}
                />
                <Handle
                    id="right-target"
                    type="target"
                    position={Position.Right}
                    style={sideHandleStyle}
                    className={handleClassName}
                    isConnectableStart={false}
                    isConnectableEnd={true}
                />
            </div>
        )
    };

    return (
        <ReusableNodes
            selected={selected}
            highlighted={data?.highlighted}
            focusMode={data?.focusMode}
            isContentExpandable={false}
            backgroundColor="#d7ffd7"
            onClick={handleNodeClick}
        >
            {data?.general_properties?.resource === undefined && (
                <NodeWarning>
                    <CustomTooltip title="No Resource data available. Please select the information." arrow placement="top" tooltipcolorstyle={theme.palette.warning.main}>
                        <ErrorIcon sx={{ color: theme.palette.warning.main, fontSize: 18, marginLeft: '2px', bgcolor: '#fff' }} />
                    </CustomTooltip>
                </NodeWarning>
            )}
            {(data?.error_dpe === true || data?.error || data?.error_text.length > 0) && (
                <NodeError>
                    <CustomTooltip title={<TooltipStatusTitle headerTitle="Error" listDetails={[...new Set([...(data?.error_dpe_text || []), ...(data?.error_text || [])])]} />} arrow placement="top" tooltipcolorstyle={theme.palette.error.main}>
                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                borderRadius: '50%',
                                background: '#fff',
                                width: 15,
                                height: 15,
                                marginTop: '5px'
                            }}
                        >
                            <ErrorIcon sx={{
                                color: theme.palette.error.main,
                                fontSize: 18,
                            }} />
                        </Box>
                    </CustomTooltip>
                </NodeError>
            )}
            <NodeHeader>
                <div className="drg-icon bg-white">
                    <svg
                        viewBox="0 0 24 24"
                        aria-hidden="true"
                        fill="none"
                        preserveAspectRatio="xMidYMid meet"
                        className="block h-6 w-6"
                    >
                        <path d="M9 3H5C4.46957 3 3.96086 3.21071 3.58579 3.58579C3.21071 3.96086 3 4.46957 3 5V9M9 3H19C19.5304 3 20.0391 3.21071 20.4142 3.58579C20.7893 3.96086 21 4.46957 21 5V9M9 3V21M3 9V19C3 19.5304 3.21071 20.0391 3.58579 20.4142C3.96086 20.7893 4.46957 21 5 21H9M3 9H21M21 9V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H9" stroke="#30D158" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                </div>
                <div className="drg-label">
                    <Typography variant="body2" className="text-gray-900" sx={{ fontWeight: 700 }}>
                        {label}
                    </Typography>
                    <Typography variant="body2" color="textSecondary" sx={{ fontSize: 14 }}>
                        {description}
                    </Typography>
                </div>
            </NodeHeader>
            <NodeHandles>
                {nodeHandles}
            </NodeHandles>
        </ReusableNodes>
    );
}